// components/HeroSearch.js
import { useState } from 'react';
import SearchBar from './SearchBar';

/**
 * HeroSearch component with gradient background and quick filters
 * Can be used on home/discipline list pages
 */
export default function HeroSearch({ 
  searchTerm = '', 
  setSearchTerm = null,
  activeFilters = { subject: 'all', grade: 'all' },
  setActiveFilters = null,
  showFilters = true,
  useVideoBackground = false,
}) {
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
  const currentFilters = activeFilters || { subject: 'all', grade: 'all' };
  const handleFilterChange = setActiveFilters || (() => {});

  const GRADES = [
    { id: '7', label: 'כיתה ז׳' },
    { id: '8', label: 'כיתה ח׳' },
    { id: '9', label: 'כיתה ט׳' },
  ];

  const SUBJECTS = [
    { id: 'tosheva', label: 'תושב״ע' },
    { id: 'tanach', label: 'תנ״ך' },
    { id: 'machshevet', label: 'מחשבת ישראל' },
    { id: 'school_rabbis', label: 'רבני בתי ספר' },
  ];

  const handleGradeClick = (gradeId) => {
    const newGrade = currentFilters.grade === gradeId ? 'all' : gradeId;
    handleFilterChange({ ...currentFilters, grade: newGrade });
  };

  const handleSubjectClick = (subjectId) => {
    const newSubject = currentFilters.subject === subjectId ? 'all' : subjectId;
    handleFilterChange({ ...currentFilters, subject: newSubject });
  };

  const heroContent = (
    <div className="relative text-white py-12 px-4">
      <div className="container-app max-w-4xl text-center relative z-10">
         <h1
           className="text-3xl md:text-5xl font-bold mb-6"
           style={{ 
             textShadow: '0 2px 8px rgba(0, 0, 0, 0.4), 0 0 14px rgba(0, 0, 0, 0.35)',
             fontWeight: '800'
           }}
         >
           <span
             className="inline-block px-6 py-3 rounded-3xl bg-gradient-to-l from-white/95 via-white/90 to-white/70 shadow-lg text-primary-900"
           >
             הקודש במרכז
           </span>
         </h1>
        <p className="text-lg md:text-xl mb-8 font-semibold" 
           style={{ 
             textShadow: '0 2px 6px rgba(0, 0, 0, 0.85), 0 0 15px rgba(0, 0, 0, 0.6)',
             fontWeight: '600'
           }}>
          הבית למורים ומורות במקצועות הקודש מבית מחוז חיפה
        </p>

        {/* Search Bar */}
        <div className="relative max-w-2xl mx-auto z-20">
          <SearchBar 
            className="w-full"
            placeholder="חפש נושא, ערך או כיתה (למשל: 'אלו מציאות', 'חנוכה')"
          />
        </div>
      </div>
    </div>
  );

  if (!useVideoBackground) {
    return (
      <div className="bg-gradient-to-br from-primary-600 to-indigo-700">
        {heroContent}
      </div>
    );
  }

  return (
    <div className="relative overflow-visible">
      {/* Background video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/assets/videos/background.mp4"
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
      />
      
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-primary-900/25" aria-hidden="true" />
      
      {/* Content wrapper with overflow control */}
      <div className="relative overflow-visible">
      {heroContent}
      </div>
    </div>
  );
}